
export enum APIAuthenticationTypeEnum {
    BASIC = "BASIC",
    BEARER = "BEARER",
    API_KEY = "API_KEY",
}
export interface APICallActionAttributes {
    method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
    url: string;
    authentication: {
        type: APIAuthenticationTypeEnum;
        username?: string;
        password?: string;
        token?: string;
        api_key_name?: string;
        api_key_value?: string;
    };
    additionalHeaders: Record<string, string>;
    encoding: 'json' | 'form' | 'xml';
    body: Record<string, any>;
    timeout?: number;
}